import { getHeaders } from "../../../utils/apiHelper";
import { pendingAbsenceApi } from "../../../utils/pendingAbsenceApi";
import { main_url } from "../../../utils/CommonFunction"

const getLeaveRequest = async (userId, setData) => {
    await fetch(main_url + `dashboard/leaveRequest/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error leave ===>", error);
    })
}
const getFuneralRequest =async (userId, setData) => {
    await fetch(main_url + `dashboard/funeralRequest/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error leave ===>", error);
    })
}

const getTeamBulidingRequest =async (userId, setData) => {
    await fetch(main_url + `dashboard/teamBuildingRequest/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error leave ===>", error);
    })
}

const getHospitalRequest =async (userId, setData) => {
    await fetch(main_url + `dashboard/hospitalRequest/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error leave ===>", error);
    })
}

const getTravelRequest =async (userId, setData) => {
    await fetch(main_url + `dashboard/travelRequest/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error travel ===>", error);
    })
}

const getMedicalRequest =async (userId, setData) => {
    await fetch(main_url + `dashboard/medicalRequest/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error medical ===>", error);
    })
}

const getExternalRequest =async (userId, setData) => {
    await fetch(main_url + `dashboard/externalRequest/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error external ===>", error);
    })
}

const getWeddingRequest =async (userId, setData) => {
    await fetch(main_url + `dashboard/weddingRequest/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error wedding ===>", error);
    })
}

const getChildRequest = async (userId, setData) => {
    await fetch(main_url + `dashboard/childRequest/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error child ===>", error);
    })
}

const getSalaryRequest =async (userId, setData) => {
    await fetch(main_url + `dashboard/salaryRequest/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error salary ===>", error);
    })
}

const getBirthdayRequest = async (userId, setData) => {
    await fetch(main_url + `dashboard/birthdayRequest/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error birthday ===>", error);
    })
}

const getConfirmationRequest =async (userId, setData) => {
    await fetch(main_url + `dashboard/confirmationRequest/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error confirmation ===>", error);
    })
}



const getCycleRequest =async (userId, setData) => {
    await fetch(main_url + `dashboard/cycleRequest/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error staff complain ===>", error);
    })
}

const getOtherRequest =async (userId, setData) => {
    await fetch(main_url + `dashboard/otherRequest/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error staff complain ===>", error);
    })
}

const getTrainingRequest =async (userId, setData) => {
    await fetch(main_url + `dashboard/trainingRequest/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error staff complain ===>", error);
    })
}

const getPhoneRequest =async (userId, setData) => {
    await fetch(main_url + `dashboard/phoneRequest/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error staff complain ===>", error);
    })
}

const getAttRequest =async (userId, setData) => {
    await fetch(main_url + `dashboard/attendance/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error staff complain ===>", error);
    })
}
const getHolidayAttRequest =async (userId, setData) => {
    await fetch(main_url + `dashboard/holiday/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error staff complain ===>", error);
    })
} 
const getStaffLoanRequest = async (userId, setData) => {
    await fetch(main_url + `dashboard/staffLoanRequest/${userId}`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error staff complain ===>", error);
    })
}
const getStaffComplainRequest  = async (userId, setData) => {
    await fetch(main_url + `dashboard/staffComplainRequest`, {
        headers: getHeaders(),
    }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch((error) => {
        console.log("error staff complain ===>", error);
    })
}

const getHelpDeskRequest =async (userId, setData) => {
    await fetch(main_url + `dashboard/helpDeskRequest/${userId}`, {
        headers: getHeaders(),
      }).then(response => {
        return response.json();
    }).then(data => {
        setData(data);
    }).catch(error => {
        console.log('error helpdesk request ===>', error);
    })
}
// Absence Compliance: correction requests waiting for this approver (0 for everyone else).
const getPendingAbsenceRequest = async (userId, setData) => {
    try {
        const data = await pendingAbsenceApi.get("/approver/count");
        setData({ count: data && data.request_count ? data.request_count : 0 });
    } catch (error) {
        console.log('error pending absence request ===>', error);
    }
}

export const thingsToDoController = {
    getLeaveRequest,
    getBirthdayRequest,
    getChildRequest,
    getExternalRequest,
    getMedicalRequest,
    getSalaryRequest,
    getTravelRequest,
    getWeddingRequest,
    getConfirmationRequest,
    getStaffComplainRequest,
    getFuneralRequest,
    getTeamBulidingRequest,
    getHospitalRequest,
    getCycleRequest,
    getOtherRequest,
    getTrainingRequest,
    getPhoneRequest,
    getHelpDeskRequest,
    getAttRequest,
    getHolidayAttRequest,
    getStaffLoanRequest,
    getPendingAbsenceRequest
}